module.exports = __webpack_public_path__ + "static/img/ios_code.592541c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ios_code.png
// module id = ChuY
// module chunks = 1